import { RevealWrapper } from '@/hooks/useRevealAnimation'
import { notices } from '@/mocks/notices'

export default function NoticeSection() {
  return (
    <section id="notices" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        {/* Header */}
        <RevealWrapper>
          <div className="reveal text-center mb-14 md:mb-20">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-secondary-500 inline-block" />
              Notices
            </div>
            <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl text-primary-700 mb-4">
              <span className="text-secondary-500">공지사항</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              다온심리상담센터의 소식과 활동 이야기를 전해드립니다.
            </p>
          </div>
        </RevealWrapper>

        {/* Notice List */}
        <div className="max-w-3xl mx-auto">
          {notices.map((notice, idx) => (
            <RevealWrapper key={notice.id}>
              <div
                className={`reveal reveal-delay-${(idx % 3) + 1} group flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 py-5 px-5 md:px-6 rounded-xl hover:bg-background-50 transition-colors border border-transparent hover:border-background-200/60 cursor-pointer`}
              >
                <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">
                  {notice.date}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-700 transition-colors truncate">
                    {notice.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
                    {notice.summary}
                  </p>
                </div>
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/60 group-hover:bg-primary-100 transition-colors shrink-0">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-s-line text-foreground-500 group-hover:text-primary-600 transition-colors" />
                  </div>
                </div>
              </div>
            </RevealWrapper>
          ))}
        </div>
      </div>
    </section>
  )
}